import { useContext } from "react"
import { WebBootContext } from "source/publishing/WebBoot"
import { useJoltChannel, useJoltEffect } from "source/hooks/useJolt"

export const ReactToPublishingJoltEvents = () => {
  const {
    currentOrganization: { id: currentOrgId },
    reactToCandidateEvents,
  } = useContext(WebBootContext)

  function handleJoltEvent(e) {
    const { data } = JSON.parse(e.data)
    reactToCandidateEvents(data)
  }

  const subscription = useJoltChannel(
    "/publishing/v2/jolt_subscribe",
    `organization-${currentOrgId}.publishing.church_center.v2.events.theme_settings`,
  )
  const joltEvents = [
    "publishing.church_center.v2.events.theme_settings.created",
  ]
  joltEvents.forEach((event) =>
    useJoltEffect(subscription, event, handleJoltEvent),
  )

  return null
}
